module.exports = __webpack_public_path__ + "img/3.f46ac67d.png";